"use client";

import { Flex } from "@chakra-ui/react";
import { Button, Text } from "@/components";
import { useThemeTokens } from "@/lib/theme/tokens";

interface AdminSelectAllMatchingBannerProps {
  entityPlural: string;
  pageCount: number;
  matchingCount: number;
  onSelectAllMatching: () => void;
  isLoading?: boolean;
  testId?: string;
}

export function AdminSelectAllMatchingBanner({
  entityPlural,
  pageCount,
  matchingCount,
  onSelectAllMatching,
  isLoading = false,
  testId = "admin-select-all-matching-banner",
}: AdminSelectAllMatchingBannerProps) {
  const theme = useThemeTokens();

  return (
    <Flex
      align={{ base: "stretch", sm: "center" }}
      justify="space-between"
      direction={{ base: "column", sm: "row" }}
      gap={3}
      mb={4}
      px={4}
      py={3}
      borderWidth="1px"
      borderColor={theme.borderGlass.default}
      borderRadius="12px"
      bg={theme.surfaceGlass.card}
      data-testid={testId}
    >
      <Text fontSize="sm" color={theme.text.secondary} lineHeight="1.5">
        All {pageCount} {entityPlural} on this page are selected.
      </Text>
      <Button
        variant="ghost"
        h="36px"
        px={3}
        fontSize="sm"
        fontWeight="600"
        color={theme.accent.primary}
        onClick={onSelectAllMatching}
        isLoading={isLoading}
        loadingText="Selecting..."
        data-testid={`${testId}-button`}
      >
        Select all {matchingCount} matching this search
      </Button>
    </Flex>
  );
}
